<div class="eidos-filter-wrapper eidos-sliderrange-filter-wrapper h-100">
  <p class="eidos-filter-label eidos-sliderrange-filter-label" *ngIf="config.label">{{ config.label }}</p>
  <eidos-input-sliderrange
    [min]="config.min" [max]="config.max"
    [(value)]="value" [(otherValue)]="otherValue"
    [tooltip]="config.tooltip" (valueChange)="config.onValueChange"
    (otherValueChange)="config.onValueChange"
    (onFocusIn)="(!!config.onFocusIn && config.onFocusIn())"
    (onFocusOut)="(!!config.onFocusOut && config.onFocusOut())"></eidos-input-sliderrange>
</div>